'use client'

import { Button } from '@vinted/web-ui'

import { ProductItemModel } from '@marketplace-web/item-box/product-item-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { clickEvent, getBumpableItemDataFromModel } from '@marketplace-web/vas/vas-data'

import useStartBumpCheckout from '../../hooks/useStartBumpCheckout'

type Props = {
  item: ProductItemModel
}

const ProfileItemBumpButton = ({ item }: Props) => {
  const { track } = useTracking()
  const translate = useTranslate('item.actions')
  const { startCheckout } = useStartBumpCheckout()

  function handleOnClick() {
    startCheckout(getBumpableItemDataFromModel(item))

    track(
      clickEvent({
        target: 'push_up_item',
        targetDetails: `${item.id}`,
        screen: 'current_user_profile',
      }),
    )
  }

  return (
    <Button
      disabled={!item.canPushUp}
      size={Button.Size.Small}
      text={translate('bump')}
      onClick={handleOnClick}
      testId="bump-button"
    />
  )
}

export default ProfileItemBumpButton
